import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { useFormik, FormikProvider } from 'formik';
import { useSnackbar } from 'notistack';
import _ from 'lodash';
import * as chanceApi from '../../lib/api/chance';
import { Box, Button, Typography } from '@mui/material';
import ChanceForecastForm from '../../components/chancemng/ChanceForecastForm';
import AskDialog from '../../components/common/dialog/AskDialog';
import CostCalcListForm from '../../components/chancemng/costcalc/CostCalcListForm';
import { computeRowAmounts } from '../../components/chancemng/costcalc/costCalcShared';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../modules/auth';
import ChanceCostCalcUploadDialog from './ChanceCostCalcUploadDialog';
import { useBoolean } from '../../hooks/useBoolean';

const ProjectForcastFormContainer = () => {
  const dispatch = useDispatch();
  const { baseCodes, user, error, loading } = useSelector(
    ({ auth, loading }) => ({
      baseCodes: auth.baseCodes,
      user: auth.user,
      error: auth.baseCodesError,
      loading: loading['auth/GET_BASECODES'],
    }),
  );
  const arrayHelperRef = useRef();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [itemCdOptions, setItemCdOptions] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [message, setMessage] = useState(
    '기본사항 등록이 완료되지 못했습니다.',
  );

  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
  };

  const showUpload = useBoolean();

  const checkValidation = () => {
    let valid = true;
    //원가산출 체크
    if (formik.values.costCalcs.length === 0) {
      setMessage(
        '원가 산출 제품을 추가하지 않았습니다. 원가 산출 내역을 확인하세요.',
      );
      valid = false;
    }

    return valid;
  };

  //id가 unquie한것만 선택.
  const onSelectedProducts = (data) => {
    const products = [...selectedProducts, ...data];
    const filteredProducts = _.uniqBy(products, 'id');

    filteredProducts.forEach((product) => {
      arrayHelperRef.current.push({
        masterTyp: 'N',
        priceUuid: product.priceUuid,
        sellPartnerUuid: product.partnerUuid,
        sellPartnerNm: product.partnerNm,
        partnerUuid: product.partnerUuid,
        partnerNm: product.partnerNm,
        productNm: product.productNm,
        productUuid: product.productUuid,
        expCnt: 1,
        unitVal: product.unitVal,
        priceVal: product.priceVal,
        productDesc: product.productDesc || '',
        productUnit: product.productUnit || '',
        itemCd: product.itemCd,
      });
    });
  };

  const handleExtProduct = () => {
    arrayHelperRef.current.push({
      masterTyp: 'E',
      priceUuid: null,
      sellPartnerUuid: '',
      sellPartnerNm: '',
      partnerUuid: null,
      partnerNm: null,
      productNm: '',
      productUuid: null,
      expCnt: 1,
      unitVal: 0,
      priceVal: 0,
      productDesc: '',
      productUnit: '',
      itemCd: '기타',
    });
  };

  let initialValues = {
    cstNm: '',
    //partnerInc: '',
    prjTyp: '',
    // incTyp: '',
    // solutionTyp: '',
    // chanceTyp: '',
    prjImpt: '',
    bugetYn: '',
    // partnerTyp: '',
    // chargeNm: '',
    // chargeEml: '',
    // chargeTel: '',
    forcastTxt: '',
    productYn: '',
    vendorCmpNm: '',
    // vendorEmp: '',
    // pmUsr: '',
    // plUsr: '',
    // techUsr: '',
    crtNm: user?.usrNm,
    crtUsr: user?.usrUuid,
    costCalcs: [],
  };

  let validationSchema = yup.object({
    cstNm: yup.string('').required('사업명을 입력하세요'),
    //partnerInc: yup.string().required('고객명을 입력하세요'),
    prjTyp: yup.string().required('프로젝트 타입을 선택하세요'),
    // incTyp: yup.string().nullable('산업체 분류를 선택하세요'),
    // solutionTyp: yup.string().nullable('아이템 구분을 선택하세요'),
    // chanceTyp: yup.string().required('기회구분을 선택하세요'),
    prjImpt: yup.string().required('프로젝트 중요도를 선택하세요'),
    bugetYn: yup.string().required('예산여부를 선택하세요'),
    //partnerTyp: yup.string().required('거래처유형을 선택하세요'),
    // chargeNm: yup.string().required('고객 담당자를 입력하세요'),
    // chargeEml: yup.string('').email('이메일 형식을 확인하세요').nullable(),
    // chargeTel: yup.string().nullable(),
    forcastTxt: yup.string().nullable(),
    productYn: yup.string().nullable('제품여부를 선택하세요'),
    vendorCmpNm: yup.string().required('매출처를 선택하세요'),
    //vendorEmp: yup.string().nullable('매출처 담당자를 선택하세요'),
    expDay: yup.date().nullable().default(undefined),
    // pmUsr: yup.string().nullable('PM을 선택하세요'),
    // plUsr: yup.string().nullable('PL을 선택하세요'),
    //techUsr: yup.string().nullable('기술담당자를 선택하세요'),
    crtUsr: yup.string().nullable('영업담당자를 선택하세요'),
    costCalcs: yup.array().of(
      yup.object().shape({
        productNm: yup.string('').required('매출내용을 입력하세요'),
        sellPartnerNm: yup.string('').required('매입처를 선택하세요'),
        expCnt: yup
          .number()
          .min(1, '최소 1 이상을 입력하세요')
          .required('수량을 입력하세요'),
        unitVal: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매출단가를 입력하세요'),
        // .min(0, '최소 0 이상을 입력하세요'),

        priceVal: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          //.min(0, '최소 0 이상을 입력하세요')
          .required('매입단가를 입력하세요'),
      }),
    ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const valid = checkValidation();

      if (!valid) {
        setVisible(true);
        return;
      } else {
        setSubmitting(true);
        onSave(values);
        formik.resetForm();
        setSubmitting(false);
      }
    },
  });

  const onMakeCaclData = () => {
    return formik.values.costCalcs.map((item) => {
      // [버그수정, 차단 1] item.saleVal/item.buyVal은 옵션 B 포팅(9bda371) 이후 더 이상
      // 렌더 중 채워지지 않는다(순수 computeRowAmounts로 뺐기 때문) - 여기서 그 값을 읽으면
      // 새 행은 NaN, 수정된 행은 옛 값으로 저장됐다. computeRowAmounts로 매 제출 시 다시
      // 계산한다(부호 수정, 02c0dea 포함).
      const { saleVal, buyVal, profit, profitRate } = computeRowAmounts(item);

      return {
        masterTyp: item.masterTyp, //기타, 일반항목 구분
        sellPartnerUuid: item.sellPartnerUuid, //매입사
        partnerUuid: item.partnerUuid, //제조사
        priceUuid: item.priceUuid,
        priceVal: item.priceVal,
        unitVal: item.unitVal,
        productNm: item.productNm,
        productUuid: item.productUuid,
        expCnt: item.expCnt,
        productDesc: item.productDesc,
        productUnit: item.productUnit,
        itemCd: item.itemCd, //아이템
        saleVal: saleVal,
        buyVal: buyVal,
        saleProfit: profit,
        salePct: profitRate,
      };
    });
  };

  const onSave = async (values) => {
    let dataToSubmit = {
      forecastInf: {
        //partnerInc: values.partnerInc,
        cstNm: values.cstNm.trim(),
        prjTyp: values.prjTyp,
        // chanceTyp: values.chanceTyp,
        prjImpt: values.prjImpt,
        bugetYn: values.bugetYn,
        // partnerTyp: values.partnerTyp,
        // chargeNm: values.chargeNm.trim(),
        // chargeEml: values.chargeEml,
        // chargeTel: values.chargeTel,
        forcastTxt: values.forcastTxt,
        // incTyp: values.incTyp,
        // solutionTyp: values.solutionTyp,
        productYn: values.productYn,
        vendorCmp: values.vendorCmp,
        //vendorEmp: values.vendorEmp,
        expDay: values.expDay
          ? dayjs(values.expDay).format('YYYY-MM-DD')
          : null,
        // pmUsr: values.pmUsr,
        // plUsr: values.plUsr,
        // techUsr: values.techUsr,
        crtUsr: values.crtUsr,
        cstGrade: 2, //2단계로 바로 등록함.
        cstStatus: '기회분석',
      },
      expenseList: onMakeCaclData(),
    };

    //console.log(JSON.stringify(dataToSubmit), 'dataToSubmit');

    try {
      const res = await chanceApi.addChanceStep2(dataToSubmit);

      if (res.data.info.forecastInf) {
        navigate(
          `/chancemng/${res.data.info.forecastInf.prjUuid}/${res.data.info.forecastInf.cstGrade}/1`,
        );
        enqueueSnackbar(`세부 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      const filteredList = _.filter(baseCodes, {
        blcCd: 'BASE',
        mlcCd: 'PRODUCT',
        slcCd: 'CATEGORY',
        useYn: 'Y',
      }).map((item) => ({
        ...item,
        step: item.step !== '' && item.step !== null ? parseInt(item.step) : 0,
      }));
      //console.log(filteredList, filterObject);
      const orderedLiist = _.orderBy(filteredList, 'step');

      setItemCdOptions(orderedLiist);
    }
  }, [baseCodes]);

  // 합계(매출/매입/이익/이익율)는 CostCalcListForm이 표 안 합계 행에서 직접 계산해 보여준다
  // (옵션 B 표 리뉴얼 전엔 여기서 따로 계산해 표 위 CostSummary에 내려줬었다).

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Button type="submit" variant="outlined" disabled={formik.isSubmitting}>
          저장
        </Button>
      </Box> */}
      <ChanceForecastForm formik={formik} />
      {formik.values.vendorCmpNm !== null &&
      formik.values.vendorCmpNm !== '' ? (
        <Box sx={{ my: 1 }}>
          <FormikProvider value={formik}>
            <CostCalcListForm
              formik={formik}
              ArrayHelperRef={arrayHelperRef}
              itemCdOptions={itemCdOptions}
              selectedVendor={formik.values.vendorCmp}
              onSelectedProducts={onSelectedProducts}
              onAddEtcProduct={handleExtProduct}
            />
          </FormikProvider>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: 1,
            }}
          >
            <Typography variant="subtitle2" color="error.main" component="div">
              매출처 선택 후 원가산출 제품 등록이 가능합니다.
            </Typography>
          </Box>
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          my: 2,
        }}
      >
        <Button type="submit" variant="outlined">
          저장
        </Button>
      </Box>
      <AskDialog
        visible={visible}
        title="등록 오류"
        description={message}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};

export default ProjectForcastFormContainer;
